module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-05.549f4be6.svg";